import styled from 'styled-components';

export const SHeaderUserContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  gap: 16px;
  margin-left: auto;
  margin-right: 16px;
`;

export const SMenuWrapper = styled.div`
  height: 100%;
`;
